import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import './PopupAddedToCart.css';

class PopupAddedToCart extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
        count: 0,
        show: false,
    };
  }

  show(count, delay = 1024) {
    this.setState(
      {count: count, show: true}, 
      () => setTimeout(() => this.hide(), delay)
    );
  }

  hide() {
    this.setState({count: 0, show: false});
  }

  render() { 
    if (this.state.show)
    {
      return <div className="popup_added_to_cart"> 
        <div className="popup_content">
          <div className="icon"><ReactSVG src="assets/images/scissors_big.svg" /></div>
          <h2>{i18n.t('addedToCartTitle')}</h2>
          <p>{i18n.t('addedToCartText', { count: this.state.count })}</p>
        </div>
      </div>;
    }
    else {
      return ''; 
    }
  }
}

export default PopupAddedToCart;
